import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

import './aboutLanding.css';
import './aboutLandingMobile.css';

const AboutLanding = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  return <section className="landing" id="landing">
    <div className="backgroundLayer" />
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="textContent">
      <div className="name">{pageContent['name']}</div>
      <div className="brief" dangerouslySetInnerHTML={{
        __html: pageContent['brief']
      }} />
    </div>
    <div className="photo">
      <img src={pageContent['image']} />
    </div>
    <div className="decorateLine"/>
    <div className="scrollHints" dangerouslySetInnerHTML={{
      __html: pageContent['scrollHints']
    }} />
    <div className="info">
      <div className="label" dangerouslySetInnerHTML={{
        __html: pageContent['label']
      }} />
      <div className="line" />
      <div className="value">{pageContent['year']}<div className="unit">{pageContent['unit']}</div></div>
      
    </div>
</section>
}

export default AboutLanding;